import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=e24f6aa6"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=e24f6aa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports